import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';

const getLandlordDashboard = async () =>
  await SuperFetch.post(apiUrls.getLandlordDashboard)
    .then(res => res)
    .catch(error => ({ error: JSON.stringify(error) }));

function* getDashboardData() {
  const userDashboard = yield call(getLandlordDashboard);
	const dashboardData = {
    properties: userDashboard.properties,
    verifications: userDashboard.verifications,
    completedReferences: userDashboard.completedReferences,
    createdReferences: userDashboard.createdReferences,
    outstandingReferences: userDashboard.outstandingReferences,
    counts: userDashboard.counts,
	};
  yield [
    put(actions.setDashboardData(dashboardData))
  ];	
}

const doJoinExcellenceProgramme = async () => {
  return await SuperFetch.post(apiUrls.joinExcellenceProgramme)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
} 
function* joinExcellenceProgramme() {
  const response = yield call(doJoinExcellenceProgramme);
  if (response) {
    yield put(actions.joinExcellenceProgrammeSucceeded(response));
  } else {
    yield put(actions.joinExcellenceProgrammeFailed(response));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_DASHBOARD_DATA, getDashboardData),
    takeEvery(actions.JOIN_EXCELLENCE_PROGRAMME, joinExcellenceProgramme),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas.js